import React from 'react';
import './parametros.css';

const CardAjustavel = ({
  src,
  title,
  subtitle,
  widht,
  height,
  eventoClick,
  className,
}) => {
  return (
    <div
      onClick={eventoClick}
      className={`card-ajustavel text-center ${className || ''}`}
      style={{
        userSelect: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        transform: 'scale(1)',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.transform = 'scale(1.02) translateY(-4px)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'scale(1) translateY(0)';
      }}
      onMouseDown={e => {
        e.currentTarget.style.transform = 'scale(0.98) translateY(-2px)';
      }}
      onMouseUp={e => {
        e.currentTarget.style.transform = 'scale(1.02) translateY(-4px)';
      }}
    >
      <div className="d-flex flex-column align-items-center justify-content-center py-3 px-2">
        <img
          src={src}
          alt={title}
          style={{
            width: widht,
            height: height,
            objectFit: 'contain',
          }}
        />
        <div
          style={{
            width: '60px',
            height: '2px',
            background: 'linear-gradient(90deg, #0747a6, #957dffff)',
            margin: '8px 0',
          }}
        />
        <span className="card-ajustavel-title">{title}</span>
        {subtitle && (
          <span className="card-ajustavel-subtitle">{subtitle}</span>
        )}
      </div>
    </div>
  );
};

export default CardAjustavel;
